<mat-toolbar>
  <mat-toolbar-row>
    <ng-container class="mat-toolbar__left">
      <div
        class="flex--column spacing--margin-right item-selector"
        *ngIf="(cycles$ | async)?.length > 0"
      >
        <mat-label class="text--small text--gray">
          {{ 'cycle-overview.cycle' | translate }}
        </mat-label>
        <mat-select
          [hideSingleSelectionIndicator]="true"
          class="text--small"
          placeholder="{{ 'cycle-overview.placeholder' | translate }}"
          data-test="cycle-overview-detailed__cycle-selector"
          [(ngModel)]="selectedCycleId"
          (selectionChange)="changeCycleSelection($event)"
        >
          <mat-option *ngFor="let cycle of cycles$ | async" [value]="cycle.id" class="text--small">
            {{ cycle.cycleNumber }}
            {{ !!cycle.cycleDate ? '(' + (cycle.cycleDate | agrDate: 'dd-MM-yyyy') : '' }}
            {{
              !!cycle.cycleEndDate
                ? '-' + (cycle.cycleEndDate | agrDate: 'dd-MM-yyyy' + ')')
                : !!cycle.cycleDate
                  ? ')'
                  : ''
            }}
          </mat-option>
        </mat-select>
      </div>
      <div class="flex--column item-selector">
        <mat-label class="text--small text--gray">
          {{ 'cycle-overview.barn' | translate }}
        </mat-label>
        <mat-select
          [hideSingleSelectionIndicator]="true"
          #barnSelector
          class="text--small"
          placeholder="{{ 'cycle-overview.placeholder' | translate }}"
          data-test="cycle-overview-detailed__barn-selector"
          [(ngModel)]="selectedBarnId"
          (ngModelChange)="changeBarnSelection($event)"
        >
          <mat-option value="all" class="text--small">{{
            'cycle-overview.option-all-barn' | translate
          }}</mat-option>
          <mat-option *ngFor="let barn of barnOptions" [value]="barn.id" class="text--small">
            {{ barn.name }} ({{ barn.surfaceArea }}m2)
          </mat-option>
        </mat-select>
      </div>
    </ng-container>

    <div class="mat-toolbar__right" *ngIf="!isMobile">
      <button
        mat-flat-button
        class="margin-right"
        (click)="deleteCycle()"
        *ngIf="selectedCycle"
        data-test="cycle-overview-detailed__delete-cycle"
      >
        <mat-icon>delete</mat-icon>{{ 'cycle-overview.delete-cycle' | translate }}
      </button>
      <button
        mat-flat-button
        (click)="editCycle()"
        *ngIf="selectedCycle"
        data-test="cycle-overview-detailed__edit-cycle"
      >
        <mat-icon>create</mat-icon>{{ 'cycle-overview.edit-cycle' | translate }}
      </button>
    </div>
  </mat-toolbar-row>
</mat-toolbar>

<div class="wrapper--spacing-vertical">
  <!-- CYCLE PANEL -->
  <app-cycle-overview-detailed-panel
    *ngIf="selectedCycleId > 0"
    panelSubject="cycle"
    [selectedCycle]="selectedCycle"
    [hasItems]="true"
    [isMobile]="isMobile"
    [showAddButton]="false"
    data-test="panel--cycle"
  >
    <div class="scroll-container">
      <div class="flex--row flex--nowrap">
        <div
          class="flex--column layout--padding-right min-column-width-60"
          data-test="cycle-overview-cycle__cyclenumber"
        >
          <div class="text--small text--gray">{{ 'cycle-number' | translate }}</div>
          <span data-test="cycle-overview-cycle__cyclenumber-value">
            {{ selectedCycle.cycleNumber }}
          </span>
        </div>
        <div
          class="flex--column layout--padding-right min-column-width-110"
          data-test="cycle-overview-cycle__surfacearea"
        >
          <div class="text--small text--gray">{{ 'area' | translate }}</div>
          <span data-test="cycle-overview-cycle__surfacearea-value">
            {{ getSurfaceArea(selectedCycle) }} m2
          </span>
        </div>
        <div
          class="flex--column layout--padding-right min-column-width-60"
          data-test="cycle-overview-cycle__concept"
        >
          <span class="text--small text--gray">{{ 'concept' | translate }}</span>
          <span data-test="cycle-overview-cycle__concept-value">
            {{ selectedCycle.concept.name }}
          </span>
        </div>
        <div
          class="flex--column layout--padding-right min-column-width-60"
          data-test="cycle-overview-cycle__feedadvice"
        >
          <span
            class="text--small text--gray"
            *ngIf="selectedCycle.feedAdviceId !== null && selectedCycle.feedAdviceId !== undefined"
          >
            {{ 'app.feed-advice' | translate }}
          </span>
          <span data-test="cycle-overview-cycle__feedadvice-value">
            {{ getFeedAdviceName(selectedCycle) | async }}
          </span>
        </div>
        <div
          class="flex--column layout--padding-right min-column-width-60"
          data-test="cycle-overview-cycle__refvalsheet"
          *ngIf="
            selectedCycle.referenceValueSheetId !== null &&
            selectedCycle.referenceValueSheetId !== undefined
          "
        >
          <span class="text--small text--gray">{{ 'app.reference-value-sheet' | translate }}</span>
          <span data-test="cycle-overview-cycle__refvalsheet-value">
            {{ getRefValSheetName(selectedCycle) | async }}
          </span>
        </div>
        <div
          class="flex--column layout--padding-right min-column-width-60"
          data-test="cycle-overview-cycle__cycleDescription"
        >
          <div class="text--small text--gray">{{ 'cycle-description' | translate }}</div>
          <span data-test="cycle-overview-cycle__cycleDescription-value">
            {{ selectedCycle.cycleDescription }}
          </span>
        </div>
      </div>
    </div>
  </app-cycle-overview-detailed-panel>

  <!-- ARRIVAL PANEL -->
  <app-cycle-overview-detailed-panel
    *ngIf="selectedCycleId > 0"
    panelSubject="day-old-chick"
    [selectedCycle]="selectedCycle"
    [totals]="dayOldChickTotals"
    [hasItems]="hasDayOldChicks"
    [isMobile]="isMobile"
    [showAddButton]="true"
    data-test="panel--day-old-chick"
  >
    <div class="scroll-container">
      <div
        class="flex--row flex--nowrap"
        *ngFor="let dayOldChick of selectedCycle?.dayOldChicks; let i = index"
      >
        <div
          class="flex--column layout--padding-right min-column-width-110"
          data-test="cycle-overview-dayOldChick__arrivalDate"
        >
          <div class="text--small text--gray" *ngIf="i === 0">
            {{ 'cycle-overview.panel.date' | translate }}
          </div>
          <div>{{ dayOldChick.arrivalDate | agrDate: 'dd-MM-yyyy' }}</div>
        </div>
        <div
          class="flex--column layout--padding-right min-column-width-110"
          data-test="cycle-overview-dayOldChick__birthDate"
        >
          <div class="text--small text--gray" *ngIf="i === 0">
            {{ 'cycle-overview.panel.birthdate' | translate }}
          </div>
          <div>{{ dayOldChick.chickBirthDate | agrDate: 'dd-MM-yyyy' }}</div>
        </div>
        <div
          class="flex--column layout--padding-right min-column-width-60"
          data-test="cycle-overview-dayOldChick__amount"
        >
          <span class="text--small text--gray" *ngIf="i === 0">
            {{ 'cycle-overview.panel.amount' | translate }}
          </span>
          <div data-test="panel--day-old-chick__detail-amountOfChicks">
            {{ dayOldChick.amountOfChicks }}
          </div>
        </div>
        <div
          class="flex--column layout--padding-right min-column-width-110"
          data-test="cycle-overview-dayOldChick__barn"
        >
          <div class="text--small text--gray" *ngIf="i === 0">
            {{ 'cycle-overview.barn' | translate }}
          </div>
          <div>{{ dayOldChick.barn.name }}</div>
        </div>
        <div
          class="flex--column layout--padding-right min-column-width-180"
          data-test="cycle-overview-dayOldChick__chicksPrice"
        >
          <div class="text--small text--gray" *ngIf="i === 0">
            {{ 'cycle-overview.panel.price-ex-vat-per-chick' | translate }}
          </div>
          <div *ngIf="dayOldChick.chicksPrice !== null">
            {{ dayOldChick.chicksPrice | agrCurrency: selectedCycle.currency }}
          </div>
          <div *ngIf="dayOldChick.chicksPrice === null">{{ 'n/a' | translate }}</div>
        </div>
        <div
          class="flex--column layout--padding-right min-column-width-110"
          data-test="cycle-overview-dayOldChick__totalPrice"
        >
          <div class="text--small text--gray" *ngIf="i === 0">
            {{ 'cycle-overview.panel.price-ex-vat' | translate }}
          </div>
          <div *ngIf="dayOldChick.chicksPrice !== null">
            {{
              dayOldChick.chicksPrice * dayOldChick.amountOfChicks
                | agrCurrency: selectedCycle.currency
            }}
          </div>
          <div *ngIf="dayOldChick.chicksPrice === null">{{ 'n/a' | translate }}</div>
        </div>
        <div
          class="flex--column layout--padding-right min-column-width-110"
          data-test="cycle-overview-dayOldChick__breed"
        >
          <div class="text--small text--gray" *ngIf="i === 0">
            {{ 'breed' | translate }}
          </div>
          <div>
            {{ dayOldChick.breed.name }}
          </div>
        </div>
        <div class="flex--column min-column-width-110" data-test="cycle-overview-dayOldChick__edit">
          <div class="text--small text--gray" *ngIf="i === 0">&nbsp;</div>
          <a
            [routerLink]="['/cycle', selectedCycle.id, 'day-old-chick', dayOldChick.id]"
            class="edit-link"
          >
            <mat-icon class="icon-small edit-link-icon">arrow_forward</mat-icon>
            <span class="edit-link-item spacing--padding-half-left">{{
              'cycle-overview.edit' | translate
            }}</span>
          </a>
        </div>
      </div>
    </div>
  </app-cycle-overview-detailed-panel>

  <!-- DEPARTURES PANEL -->
  <app-cycle-overview-detailed-panel
    *ngIf="selectedCycleId > 0"
    panelSubject="departure"
    [selectedCycle]="selectedCycle"
    [totals]="departureTotals"
    [hasItems]="hasDepartures"
    [isMobile]="isMobile"
    [showAddButton]="true"
    data-test="panel--departure"
  >
    <div class="scroll-container">
      <div
        class="flex--row flex--nowrap"
        data-test="panel--departure__totals"
        *ngFor="let departure of selectedCycle?.departures; let i = index"
      >
        <div
          class="flex--column layout--padding-right min-column-width-110"
          data-test="cycle-overview-departure__departureDate"
        >
          <div class="text--small text--gray" *ngIf="i === 0">
            {{ 'cycle-overview.panel.departuredate' | translate }}
          </div>
          <div>{{ departure.departureDate | agrDate: 'dd-MM-yyyy' }}</div>
        </div>

        <div
          class="flex--column layout--padding-right min-column-width-60"
          data-test="cycle-overview-departure__amount"
        >
          <div class="text--small text--gray" *ngIf="i === 0">
            {{ 'cycle-overview.panel.amount' | translate }}
          </div>
          <div>{{ departure.amountOfChicks }}</div>
        </div>
        <div
          class="flex--column layout--padding-right min-column-width-110"
          data-test="cycle-overview-departure__weight"
        >
          <div class="text--small text--gray" *ngIf="i === 0">
            {{ 'cycle-overview.panel.departureweight' | translate }}
          </div>
          <div>{{ departure.departureWeight }}</div>
        </div>
        <div
          class="flex--column layout--padding-right min-column-width-140"
          data-test="cycle-overview-departure__slaughterWeight"
        >
          <div class="text--small text--gray" *ngIf="i === 0">
            {{ 'cycle-overview.panel.slaughterweight' | translate }}
          </div>
          <div>{{ departure.slaughterWeight }}</div>
        </div>
        <div
          class="flex--column layout--padding-right min-column-width-110"
          data-test="cycle-overview-departure__barn"
        >
          <div class="text--small text--gray" *ngIf="i === 0">
            {{ 'cycle-overview.barn' | translate }}
          </div>
          <div>{{ departure.barn.name }}</div>
        </div>
        <div
          class="flex--column layout--padding-right min-column-width-140"
          data-test="cycle-overview-departure__price"
        >
          <div class="text--small text--gray" *ngIf="i === 0">
            {{ 'cycle-overview.panel.price-ex-vat' | translate }}
          </div>
          <div *ngIf="departure.revenue !== null">
            {{ departure.revenue | agrCurrency: selectedCycle.currency }}
          </div>
          <div *ngIf="departure.revenue === null">{{ 'n/a' | translate }}</div>
        </div>
        <div
          class="flex--column layout--padding-right min-column-width-140"
          data-test="cycle-overview-departure__type"
        >
          <div class="text--small text--gray" *ngIf="i === 0">
            {{ 'cycle-overview.panel.type' | translate }}
          </div>
          <div>
            {{ 'cycle-overview.panel.type-' + departure.type.toString().toLowerCase() | translate }}
          </div>
        </div>
        <div class="flex--column min-column-width-110" data-test="cycle-overview-departure__edit">
          <div class="text--small text--gray" *ngIf="i === 0">&nbsp;</div>
          <a
            [routerLink]="['/cycle', selectedCycle.id, 'departure', departure.id]"
            class="edit-link"
          >
            <mat-icon class="icon-small edit-link-icon">arrow_forward</mat-icon>
            <span class="edit-link-item spacing--padding-half-left">{{
              'cycle-overview.edit' | translate
            }}</span>
          </a>
        </div>
      </div>
    </div>
  </app-cycle-overview-detailed-panel>

  <!-- SUMMARY PANEL -->
  <app-cycle-overview-detailed-panel
    *ngIf="selectedCycleId > 0"
    panelSubject="balance"
    [selectedCycle]="selectedCycle"
    [totals]="feedConsumptionTotals"
    [hasItems]="feedConsumptionSummary !== undefined"
    [isMobile]="isMobile"
    data-test="panel--balance"
  >
    <div *ngIf="feedConsumptionSummary !== undefined; else noBalance" class="scroll-container">
      <div
        class="flex--row flex--nowrap"
        data-test="panel--balance__totals"
        *ngFor="let productType of feedConsumptionSummary?.consumptionPerProductType; let i = index"
      >
        <div
          class="flex--column layout--padding-right min-column-width-180"
          data-test="cycle-overview-consumption__type"
        >
          <div class="text--small text--gray" *ngIf="i === 0">
            {{ 'cycle-overview.panel.type' | translate }}
          </div>
          <div>
            {{
              'cycle-overview.panel.product-type-' + productType.productType.toLowerCase()
                | translate
            }}
          </div>
        </div>
        <div
          class="flex--column layout--padding-right min-column-width-140"
          data-test="cycle-overview-consumption__amount"
        >
          <div class="text--small text--gray" *ngIf="i === 0">
            {{ 'cycle-overview.panel.consumption' | translate }}
          </div>
          <div>
            {{ productType.consumption | agrNumber }}
          </div>
        </div>
        <div
          class="flex--column layout--padding-right min-column-width-180"
          data-test="cycle-overview-consumption__perChcick"
        >
          <div class="text--small text--gray" *ngIf="i === 0">
            {{ 'cycle-overview.panel.consumption-per-chick' | translate }}
          </div>
          <div>
            {{ productType.consumptionPerDeliveredChick | agrNumber }}
          </div>
        </div>
        <div
          class="flex--column layout--padding-right min-column-width-140"
          data-test="cycle-overview-consumption__price"
        >
          <div class="text--small text--gray" *ngIf="i === 0">
            {{ 'cycle-overview.panel.price-ex-vat' | translate }}
          </div>
          <div *ngIf="productType.price !== null">
            {{ productType.price | agrCurrency: selectedCycle.currency }}
          </div>
          <div *ngIf="productType.price === null">{{ 'n/a' | translate }}</div>
        </div>
      </div>
    </div>

    <ng-template #noBalance>
      <div class="text--small text--bold" data-test="panel--balance__empty">
        {{ 'cycle-overview.consumption-empty.title' | translate }}
      </div>
      <div class="text--small text--gray">
        {{ 'cycle-overview.consumption-empty.description' | translate }}
      </div>
    </ng-template>
  </app-cycle-overview-detailed-panel>

  <!-- DISCOUNTS PANEL -->
  <app-cycle-overview-detailed-panel
    *ngIf="selectedCycleId > 0 && canNavigate$ | async"
    panelSubject="discount"
    [selectedCycle]="selectedCycle"
    [hasItems]="hasDiscounts"
    [isMobile]="isMobile"
    data-test="panel--discount"
  >
    <div *ngIf="hasDiscounts; else noDiscount" class="scroll-container">
      <div
        class="flex--row flex--nowrap"
        data-test="panel--discount__totals"
        *ngFor="let discount of selectedCycle?.discounts; let i = index"
      >
        <div
          class="flex--column layout--padding-right min-column-width-140"
          data-test="discount__applicabilityType"
        >
          <div class="text--small text--gray" *ngIf="i === 0">
            {{ 'discount-applicabilityType' | translate }}
          </div>
          <div>
            {{
              'discount-item.applicabilityType-' +
                discount.applicabilityType.toString().toLowerCase() | translate
            }}
          </div>
        </div>

        <div
          class="flex--column layout--padding-right min-column-width-220"
          data-test="discount__label"
        >
          <div class="text--small text--gray" *ngIf="i === 0">
            {{ 'discount-label' | translate }}
          </div>
          <div>
            {{ 'discount-item.labelType-' + discount.label.toString().toLowerCase() | translate }}
          </div>
        </div>

        <div
          class="flex--column layout--padding-right min-column-width-110"
          data-test="discount__barn"
        >
          <div class="text--small text--gray" *ngIf="i === 0">
            {{ 'cycle-overview.barn' | translate }}
          </div>
          <div>{{ discount.barn.name }}</div>
        </div>

        <div
          class="flex--column layout--padding-right min-column-width-140"
          data-test="discount__amount"
        >
          <div class="text--small text--gray" *ngIf="i === 0">
            {{ 'discount-amount' | translate }}
          </div>
          <div>{{ discount.amount | agrCurrency: selectedCycle.currency }}</div>
        </div>
      </div>
    </div>

    <ng-template #noDiscount>
      <div class="text--small text--bold" data-test="panel--discount__empty">
        {{ 'discount.no-discounts-title' | translate }}
      </div>
      <div class="text--small text--gray">
        {{ 'discount.no-discounts-description' | translate }}
      </div>
    </ng-template>
  </app-cycle-overview-detailed-panel>
</div>

<agr-notification-empty
  [isEmpty]="(cycles$ | async)?.length > 0 && !selectedCycle"
  [emptyTitle]="'no-cycle-selected-title' | translate"
  [emptyDescription]="'no-cycle-selected-description' | translate"
  emptyImage="assets/images/flock-cycle.jpg"
>
</agr-notification-empty>
